module.exports = __webpack_public_path__ + "img/fixed-banner2023.23e8d497.png";